import { motion } from "framer-motion";
import { X, Bell, Calendar, Mail, MessageSquare, Image } from "lucide-react";

interface NotificationCenterProps {
  isOpen: boolean;
  onClose: () => void;
}

export function NotificationCenter({ isOpen, onClose }: NotificationCenterProps) {
  const today = new Date();

  return (
    <motion.div
      initial={{ y: "-100%" }}
      animate={{ y: isOpen ? 0 : "-100%" }}
      transition={{ type: "spring", damping: 25, stiffness: 200 }}
      className="absolute inset-0 z-50 flex flex-col bg-black/90 backdrop-blur-xl p-6 pt-12"
    >
      {/* Date Display */}
      <div className="mb-8">
        <h2 className="text-3xl font-semibold text-white">
          {today.toLocaleDateString("en-US", { weekday: "long" })}
        </h2>
        <p className="text-lg text-white/60">
          {today.toLocaleDateString("en-US", { month: "long", day: "numeric" })}
        </p>
      </div>

      {/* Widgets */}
      <div className="grid grid-cols-2 gap-3">
        {/* Calendar Widget */}
        <div className="rounded-2xl bg-white/10 p-4">
          <div className="flex items-center gap-2">
            <Calendar className="h-5 w-5 text-red-500" />
            <span className="text-white/60 text-xs">Calendar</span>
          </div>
          <p className="mt-2 text-white text-sm">No Events Today</p>
        </div>

        {/* Weather Widget */}
        <div className="rounded-2xl bg-white/10 p-4">
          <div className="flex items-center gap-2">
            <span className="text-2xl">☀️</span>
            <div>
              <p className="text-white text-lg font-semibold">72°</p>
              <p className="text-white/60 text-xs">Sunny</p>
            </div>
          </div>
        </div>
      </div>

      {/* Notifications List */}
      <div className="mt-6 flex-1 overflow-y-auto">
        <div className="text-center text-white/40 py-8">
          <Bell className="h-12 w-12 mx-auto mb-4 opacity-50" />
          <p className="text-sm">No New Notifications</p>
        </div>
      </div>

      {/* Home Indicator */}
      <div className="pt-2">
        <div className="mx-auto h-1 w-32 rounded-full bg-white/30" />
      </div>
    </motion.div>
  );
}